import "core-js/modules/es6.reflect.construct.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["component", "disabled", "className", "clsPrefix", "children", "style", "name", "action", "headers", "data", "type", "listType", "fileList", "defaultFileList", "size", "beforeUpload", "showUploadList", "supportServerRender", "onStart", "onSuccess", "multipart", "onReady", "customRequest", "withCredentials", "onChange"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import "core-js/modules/es6.function.name.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
* This source code is quoted from rc-upload.
* homepage: https://github.com/react-component/upload
*/
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import getUid from './uid';
import warning from 'warning';
import PropTypes from 'prop-types';
var IFRAME_STYLE = {
  position: 'absolute',
  top: 0,
  opacity: 0,
  filter: 'alpha(opacity=0)',
  left: 0,
  zIndex: 9999
};
var propTypes = {
  component: PropTypes.string,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  clsPrefix: PropTypes.string,
  className: PropTypes.string,
  accept: PropTypes.string,
  onStart: PropTypes.func,
  multiple: PropTypes.bool,
  children: PropTypes.any,
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),
  action: PropTypes.string,
  name: PropTypes.string
}; // diferent from AjaxUpload, can only upload on at one time, serial seriously

var IframeUploader = /*#__PURE__*/function (_Component) {
  _inherits(IframeUploader, _Component);

  var _super = _createSuper(IframeUploader);

  function IframeUploader(props) {
    var _this;

    _classCallCheck(this, IframeUploader);

    _this = _super.call(this, props);
    _this.file = {};
    _this.state = {
      uploading: false
    };
    _this.onLoad = _this.onLoad.bind(_assertThisInitialized(_this));
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.getIframeNode = _this.getIframeNode.bind(_assertThisInitialized(_this));
    _this.getIframeDocument = _this.getIframeDocument.bind(_assertThisInitialized(_this));
    _this.getFormNode = _this.getFormNode.bind(_assertThisInitialized(_this));
    _this.getFormInputNode = _this.getFormInputNode.bind(_assertThisInitialized(_this));
    _this.getFormDataNode = _this.getFormDataNode.bind(_assertThisInitialized(_this));
    _this.getFileForMultiple = _this.getFileForMultiple.bind(_assertThisInitialized(_this));
    _this.getIframeHTML = _this.getIframeHTML.bind(_assertThisInitialized(_this));
    _this.initIframeSrc = _this.initIframeSrc.bind(_assertThisInitialized(_this));
    _this.initIframe = _this.initIframe.bind(_assertThisInitialized(_this));
    _this.endUpload = _this.endUpload.bind(_assertThisInitialized(_this));
    _this.startUpload = _this.startUpload.bind(_assertThisInitialized(_this));
    _this.updateIframeWH = _this.updateIframeWH.bind(_assertThisInitialized(_this));
    _this.abort = _this.abort.bind(_assertThisInitialized(_this));
    _this.post = _this.post.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(IframeUploader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateIframeWH();
      this.initIframe();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateIframeWH();
    }
  }, {
    key: "onLoad",
    value: function onLoad() {
      if (!this.state.uploading) {
        return;
      }

      var props = this.props,
          file = this.file;
      var response;

      try {
        var doc = this.getIframeDocument();
        var script = doc.getElementsByTagName('script')[0];

        if (script && script.parentNode === doc.body) {
          doc.body.removeChild(script);
        }

        response = doc.body.innerHTML;
        props.onSuccess(response, file);
      } catch (err) {
        warning(false, 'cross domain error for Upload. Maybe server should return document.domain script. see Note from https://github.com/react-component/upload');
        response = 'cross-domain';
        props.onError(err, null, file);
      }

      this.endUpload();
    }
  }, {
    key: "onChange",
    value: function onChange() {
      var _this2 = this;

      var target = this.getFormInputNode(); // ie8/9 don't support FileList Object
      // http://stackoverflow.com/questions/12830058/ie8-input-type-file-get-files

      var file = this.file = {
        uid: getUid(),
        name: target.value
      };
      this.startUpload();
      var props = this.props;

      if (!props.beforeUpload) {
        return this.post(file);
      }

      var before = props.beforeUpload(file);

      if (before && before.then) {
        before.then(function () {
          _this2.post(file);
        }, function () {
          _this2.endUpload();
        });
      } else if (before !== false) {
        this.post(file);
      } else {
        this.endUpload();
      }
    }
  }, {
    key: "getIframeNode",
    value: function getIframeNode() {
      return this.iframe;
    }
  }, {
    key: "getIframeDocument",
    value: function getIframeDocument() {
      return this.getIframeNode().contentDocument;
    }
  }, {
    key: "getFormNode",
    value: function getFormNode() {
      return this.getIframeDocument().getElementById('form');
    }
  }, {
    key: "getFormInputNode",
    value: function getFormInputNode() {
      return this.getIframeDocument().getElementById('input');
    }
  }, {
    key: "getFormDataNode",
    value: function getFormDataNode() {
      return this.getIframeDocument().getElementById('data');
    }
  }, {
    key: "getFileForMultiple",
    value: function getFileForMultiple(file) {
      return this.props.multiple ? [file] : file;
    }
  }, {
    key: "getIframeHTML",
    value: function getIframeHTML(domain) {
      var domainScript = '';
      var domainInput = '';

      if (domain) {
        domainScript = "<script>document.domain=\"".concat(domain, "\";</script>");
        domainInput = "<input name=\"_documentDomain\" value=\"".concat(domain, "\" />");
      }

      return "\n    <!DOCTYPE html>\n    <html>\n    <head>\n    <meta http-equiv=\"X-UA-Compatible\" content=\"IE=edge\" />\n    <style>\n    body,html {padding:0;margin:0;border:0;overflow:hidden;}\n    </style>\n    ".concat(domainScript, "\n    </head>\n    <body>\n    <form method=\"post\"\n    encType=\"multipart/form-data\"\n    action=\"").concat(this.props.action, "\" id=\"form\"\n    style=\"display:block;height:9999px;position:relative;overflow:hidden;\">\n    <input id=\"input\" type=\"file\"\n     name=\"").concat(this.props.name, "\"\n     style=\"position:absolute;top:0;right:0;height:9999px;font-size:9999px;cursor:pointer;\"/>\n    ").concat(domainInput, "\n    <span id=\"data\"></span>\n    </form>\n    </body>\n    </html>\n    ");
    }
  }, {
    key: "initIframeSrc",
    value: function initIframeSrc() {
      if (this.domain) {
        this.getIframeNode().src = "javascript:void((function(){\n        var d = document;\n        d.open();\n        d.domain='".concat(this.domain, "';\n        d.write('');\n        d.close();\n      })())");
      }
    }
  }, {
    key: "initIframe",
    value: function initIframe() {
      var iframeNode = this.getIframeNode();
      var win = iframeNode.contentWindow;
      var doc;
      this.domain = this.domain || '';
      this.initIframeSrc();

      try {
        doc = win.document;
      } catch (e) {
        this.domain = document.domain;
        this.initIframeSrc();
        win = iframeNode.contentWindow;
        doc = win.document;
      }

      doc.open('text/html', 'replace');
      doc.write(this.getIframeHTML(this.domain));
      doc.close();
      this.getFormInputNode().onchange = this.onChange;
    }
  }, {
    key: "endUpload",
    value: function endUpload() {
      if (this.state.uploading) {
        this.file = {}; // hack avoid batch

        this.state.uploading = false;
        this.setState({
          uploading: false
        });
        this.initIframe();
      }
    }
  }, {
    key: "startUpload",
    value: function startUpload() {
      if (!this.state.uploading) {
        this.state.uploading = true;
        this.setState({
          uploading: true
        });
      }
    }
  }, {
    key: "updateIframeWH",
    value: function updateIframeWH() {
      var rootNode = ReactDOM.findDOMNode(this);
      var iframeNode = this.getIframeNode();
      iframeNode.style.height = "".concat(rootNode.offsetHeight, "px");
      iframeNode.style.width = "".concat(rootNode.offsetWidth, "px");
    }
  }, {
    key: "abort",
    value: function abort(file) {
      if (file) {
        var uid = file;

        if (file && file.uid) {
          uid = file.uid;
        }

        if (uid === this.file.uid) {
          this.endUpload();
        }
      } else {
        this.endUpload();
      }
    }
  }, {
    key: "post",
    value: function post(file) {
      var formNode = this.getFormNode();
      var dataSpan = this.getFormDataNode();
      var data = this.props.data;
      var onStart = this.props.onStart;

      if (typeof data === 'function') {
        data = data(file);
      }

      var inputs = [];

      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          inputs.push("<input name=\"".concat(key, "\" value=\"").concat(data[key], "\"/>"));
        }
      }

      dataSpan.innerHTML = inputs.join('');
      formNode.submit();
      dataSpan.innerHTML = '';
      onStart(file);
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _this3 = this;

      var _this$props = this.props,
          Tag = _this$props.component,
          disabled = _this$props.disabled,
          className = _this$props.className,
          clsPrefix = _this$props.clsPrefix,
          children = _this$props.children,
          style = _this$props.style,
          name = _this$props.name,
          action = _this$props.action,
          headers = _this$props.headers,
          data = _this$props.data,
          type = _this$props.type,
          listType = _this$props.listType,
          fileList = _this$props.fileList,
          defaultFileList = _this$props.defaultFileList,
          size = _this$props.size,
          beforeUpload = _this$props.beforeUpload,
          showUploadList = _this$props.showUploadList,
          supportServerRender = _this$props.supportServerRender,
          onStart = _this$props.onStart,
          onSuccess = _this$props.onSuccess,
          multipart = _this$props.multipart,
          onReady = _this$props.onReady,
          customRequest = _this$props.customRequest,
          withCredentials = _this$props.withCredentials,
          onChange = _this$props.onChange,
          others = _objectWithoutProperties(_this$props, _excluded);

      var iframeStyle = _objectSpread(_objectSpread({}, IFRAME_STYLE), {}, {
        display: this.state.uploading || disabled ? 'none' : ''
      });

      var cls = classNames((_classNames = {}, _defineProperty(_classNames, clsPrefix, true), _defineProperty(_classNames, "".concat(clsPrefix, "-disabled"), disabled), _defineProperty(_classNames, className, className), _classNames));
      return /*#__PURE__*/React.createElement(Tag, _extends({
        className: cls,
        style: _objectSpread({
          position: 'relative',
          zIndex: 0
        }, style)
      }, others), /*#__PURE__*/React.createElement("iframe", {
        // ref="iframe"
        ref: function ref(el) {
          return _this3.iframe = el;
        },
        onLoad: this.onLoad,
        style: iframeStyle
      }), children);
    }
  }]);

  return IframeUploader;
}(Component);

;
IframeUploader.propTypes = propTypes;
export default IframeUploader;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-upload/src/IframeUploader.js